"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.GRAPHQL_ENDPOINTS = exports.GPLSESSION_PROGRAMS = exports.GPLCORE_PROGRAMS = void 0;
var anchor = __importStar(require("@project-serum/anchor"));
exports.GPLCORE_PROGRAMS = {
    "mainnet-beta": new anchor.web3.PublicKey("CDDMdCAWB5AXgvEy7XJRggAu37QPG1b9aJXndZoPUkkm"),
    devnet: new anchor.web3.PublicKey("CDDMdCAWB5AXgvEy7XJRggAu37QPG1b9aJXndZoPUkkm"),
    localnet: new anchor.web3.PublicKey("CDDMdCAWB5AXgvEy7XJRggAu37QPG1b9aJXndZoPUkkm"),
    testnet: new anchor.web3.PublicKey("9XZ9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z9Y9Z")
};
exports.GPLSESSION_PROGRAMS = {
    "mainnet-beta": new anchor.web3.PublicKey("2AfeS4zYgZoBK33xED7opF1gPxZMWjj8cAJiGqjtFnLH"),
    devnet: new anchor.web3.PublicKey("2AfeS4zYgZoBK33xED7opF1gPxZMWjj8cAJiGqjtFnLH"),
    localnet: new anchor.web3.PublicKey("2AfeS4zYgZoBK33xED7opF1gPxZMWjj8cAJiGqjtFnLH")
};
exports.GRAPHQL_ENDPOINTS = {
    devnet: "https://light-pelican-32.hasura.app/v1/graphql"
};
